// 📁 components/TabelaGenerica.jsx
import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { TbPencil, TbTrash } from "react-icons/tb";

export default function Tabela({
    data = [],
    columns = [],
    loading = false,
    currentPage,
    totalPages,
    setCurrentPage,
    searchTerm,
    setSearchTerm,
    onSearch,
    onEdit,
    onDelete,
    corTerciaria = "#007bff",
    permissaoEdicao = false,
}) {
    const [localInput, setLocalInput] = useState(searchTerm || "");

    useEffect(() => {
        setLocalInput(searchTerm || "");
    }, [searchTerm]);

    const commitSearch = (value) => {
        // atualiza o searchTerm no pai (committed) e chama onSearch opcional
        setCurrentPage && setCurrentPage(1);
        setSearchTerm && setSearchTerm(value);
        onSearch && onSearch(value);
    };

    return (
        <div style={{ padding: "0 16px" }}>
            {/* 🔍 Campo de filtro */}
            <div
                className="filtro-container"
                style={{
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <div style={{ position: "relative", width: "100%", maxWidth: "400px" }}>
                    <input
                        type="text"
                        placeholder="Pesquisar..."
                        className="form-control"
                        value={localInput}
                        onChange={(e) => {
                            // atualiza só o input local — NÃO atualiza o searchTerm do pai aqui
                            setLocalInput(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                commitSearch(localInput.trim());
                            }
                        }}
                        style={{
                            width: "100%",
                            paddingRight: "30px",
                            border: "none",
                            borderBottom: "2px solid #ccc",
                            outline: "none",
                            fontSize: "14px",
                            background: "transparent",
                            borderRadius: "0",
                        }}
                        onFocus={(e) =>
                            (e.target.style.borderBottom = "2px solid #007bff")
                        }
                        onBlur={(e) => (e.target.style.borderBottom = "2px solid #ccc")}
                    />
                    <FaSearch
                        style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#888",
                            cursor: "pointer",
                        }}
                        onClick={() => commitSearch(localInput.trim())}
                    />
                </div>

            </div>

            {/* 🌀 Loading */}
            {loading ? (
                <div className="loading-screen">
                    <div className="loader-container">
                        <div className="spinner"></div>
                    </div>
                </div>
            ) : (
                <>
                    {/* 🧾 Tabela */}
                    <table
                        className="table table-hover"
                        style={{
                            tableLayout: "fixed",
                            width: "100%",
                            borderCollapse: "collapse",
                        }}
                    >
                        <thead>
                            <tr className="span-bsc">
                                {columns.map((col, i) => (
                                    <th
                                        key={i}
                                        style={{
                                            width: col.width || "auto",
                                            textAlign: col.align || "left",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((item, idx) => (
                                    <tr key={idx} className="span-bsc">
                                        {columns.map((col, i) => (
                                            <td key={i} style={{ textAlign: col.align || "left" }}>
                                                {col.render ? col.render(item) : item[col.field]}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr className="span-bsc">
                                    <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                        Nenhum registro encontrado
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* 📄 Paginação */}
                    {totalPages >= 1 && (
                        <div
                            className="paginacao"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px",
                                marginTop: "20px",
                                flexWrap: "wrap",
                            }}
                        >
                            <button
                                disabled={currentPage === 1}
                                style={{
                                    backgroundColor: "#f1f1f1",
                                    color: "#333",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                }}
                                onClick={() => setCurrentPage((p) => p - 1)}
                            >
                                &lt;
                            </button>

                            {Array.from({ length: totalPages }).map((_, i) => {
                                const page = i + 1;
                                return (
                                    <button
                                        key={page}
                                        onClick={() => setCurrentPage(page)}
                                        style={{
                                            backgroundColor:
                                                page === currentPage ? corTerciaria : "#f1f1f1",
                                            color: page === currentPage ? "#fff" : "#333",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "32px",
                                            height: "32px",
                                        }}
                                    >
                                        {page}
                                    </button>
                                );
                            })}

                            <button
                                disabled={currentPage === totalPages}
                                style={{
                                    backgroundColor: "#f1f1f1",
                                    color: "#333",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                }}
                                onClick={() => setCurrentPage((p) => p + 1)}
                            >
                                &gt;
                            </button>

                            <span style={{ marginLeft: "10px", fontSize: "0.85rem" }} className="span-bsc">
                                Página {currentPage} de {totalPages}
                            </span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
